import { TQueryDocumentSnapshot } from "common/types/FirebaseTypes";
import { FirebaseDocument } from "common/models/FirebaseDocument";

export class CustomPropertyModel {
  constructor(public label: string, public renderInEAP: boolean = false) {}

  public toJSON(): object {
    return {
      label: this.label,
      renderInEAP: this.renderInEAP,
    };
  }

  public static createFrom(doc: TQueryDocumentSnapshot) {
    if (doc.exists) {
      const data = doc.data();
      if (data) {
        const model = new CustomPropertyModel(data.label, data.renderInEAP);
        return new FirebaseDocument(doc.id, model);
      }
    }
    return new FirebaseDocument(doc.id, CustomPropertyModel.getDefault());
  }

  public static getDefault() {
    return new CustomPropertyModel("", false);
  }
}



// WEBPACK FOOTER //
// ./src/modules/customProperties/CustomPropertyModel.tsx